export const useDynamicTranslation = () => {
  const localeStore = useLocaleStore()
  const { selectedLanguage } = storeToRefs(localeStore)

  const { t } = useI18n()

  const translate = (key: string) => {
    return t(key, 1, { locale: selectedLanguage.value, default: key })
  }

  return {
    translate
  }
}
